if(!customElements.get("product-lightbox")) {
  class ProductLightbox extends HTMLElement {
    constructor() {
      super();

      // Configurations
      this.backdrop = this.querySelector('.product-lightbox__background');
      this.closeButton = this.querySelector('[data-close-modal]');

      // Listeners
      this.closeLightBox = this.closeLightBox.bind(this);
      this.openLightBox = this.openLightBox.bind(this);
      this.backdrop.addEventListener("click", this.closeLightBox, false);
      this.closeButton.addEventListener("click", this.closeLightBox, false);
    }
  
    connectedCallback() {
      this.initProductLightbox();
    }

    initProductLightbox() {
      const openLightboxEls = document.querySelectorAll("[data-open-lightbox]");
      if (!openLightboxEls) return;
      openLightboxEls.forEach((image) => {
        image.addEventListener("click", this.openLightBox, false);
      });
    }

    closeLightBox() {
      this.classList.add("hidden");
    }

    openLightBox() {
      this.classList.remove("hidden");
    }
  }

  customElements.define('product-lightbox', ProductLightbox);
}